import { type JSONObject, Temporal } from '@imago/api-client'
import { type YCBM_IntentSecret } from '@imago/api-client-ycbm'
import { type ServiceID } from './ServiceProduct.ts'

export interface AppointmentInfo {
	serviceID: ServiceID
	start: Temporal.ZonedDateTime
	end: Temporal.ZonedDateTime
	duration: Temporal.Duration

	googleMeetLink?: string

	ycbm_secret?: YCBM_IntentSecret
}

export interface AppointmentInfoJSON extends JSONObject {
	serviceID: ServiceID
	start: Temporal.ZonedDateTime_ISO
	end: Temporal.ZonedDateTime_ISO
	duration: Temporal.Duration_ISO

	googleMeetLink?: string

	ycbm_secret?: YCBM_IntentSecret
}

export function serializeAppointmentInfo(app: AppointmentInfo): AppointmentInfoJSON {
	return {
		...app,
		start: !app.start ? app.start : app.start.toString() as any, // TODO fix toString typing
		end: !app.end ? app.end : app.end.toString() as any, // TODO fix toString typing
		duration: !app.duration ? app.duration : app.duration.toString() as any, // TODO fix toString typing
	}
}

export function deserializeAppointmentInfo(app: AppointmentInfoJSON): AppointmentInfo {
	return {
		...app,
		start: !app.start ? app.start : Temporal.ZonedDateTime.from(app.start),
		end: !app.end ? app.end : Temporal.ZonedDateTime.from(app.end),
		duration: !app.duration ? app.duration : Temporal.Duration.from(app.duration),
	}
}
